import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import Input from './Input';

class InputMasked extends AbstractComponent {       
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            erro: ''
        }
    }   

    onChange(e) {                       
        var regexp = new RegExp(this.props.pattern);        

        if((e.target.value !== '')&&(!regexp.test(e.target.value))) {
            e.target.value = this.state.value;
            
            this.setState({erro: 'Entrada de dados inválida, somente é permitido letras e números!'});

            return;
        }

        this.setState({
            value: e.target.value, 
            erro: ''
        });

        this.props.onChange(e);
    }   

    erro() {
        return this.props.erro !== undefined && this.props.erro !== ''
            ? this.props.erro
            : this.state.erro
    }

    render() {
        return (
            <Input
                md={12} 
                xs={12} 
                sm={12} 
                lg={12}
                style={this.props.style}
                id={this.props.id}
                nome={this.props.nome}
                value={this.props.value}
                defaultValue={this.props.defaultValue}  
                disabled={this.props.disabled}              
                erro={this.erro()}
                onChange={(e) => this.onChange(e)}
            >                    
                {this.props.children}
            </Input>
        )
    }
}

export default InputMasked;